<template>
  <button
    class="c-sidebar-minimizer"
    type="button"
  >
  </button>
</template>

<script>
export default {
  name: 'CSidebarMinimizer'
}
</script>
